// extracted by mini-css-extract-plugin
export default {"nestableLink":"NestableLink-module__nestableLink--jedIf","underlay":"NestableLink-module__underlay--n8rwQ","allowInsideLinks":"NestableLink-module__allowInsideLinks--lCab5"};